import { getParams } from '@frontend/common/ph-router-store';
import { createSelector } from '@ngrx/store';

export const getDepartmentId = createSelector(
  getParams,
  (params) => params.department_id
);
